<template>
  <div class="m-l-50 m-t-30">
    <div class="form-left fl ">
      <el-form ref="form" :model="form" :rules="rules" class="p-r-10 m-r-10 left-content  bor-r-ccc" v-loading="loading">
        <el-form-item label="功能集名称" prop="name">
          <el-input v-model.trim="form.name" class="h-40 w-200" placeholder="请填写功能集名称"></el-input>
        </el-form-item>
        <el-form-item label="层级" label-width="100px">
          <el-radio-group v-model="form.level">
            <el-radio :label="10">一级层级</el-radio>
            <el-radio :label="20">二级层级</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="复制配置" v-if="!id">
          <el-select v-model="cloneId" placeholder="选择功能集" class="w-200">
            <el-option v-for="item in configs" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-button @click="cloneConfig">复制</el-button>
        </el-form-item>
        <el-form-item label="功能集布局配置" prop="tab" v-show="isSecondLevel">
          <content-table ref="contentTable" :content="form.content" :contentsById="contentsById" @setCurContent="setCurContent" @deleteContent="deleteContent"></content-table>
          <div class="m-t-10 tx-c">
            <el-button type="primary" @click="addContent">添加内容</el-button>
          </div>
        </el-form-item>
        <el-form-item label="菜单配置" prop="list_config">
          <menu-table ref="menuTable" :menu="form.menu" :menusById="menusById" @deleteMenu="deleteMenu" @resetMenu="resetMenu" @setCurMenu="setCurMenu"></menu-table>
          <div class="m-t-10 tx-c" v-if="!hasMenu">
            <el-button type="primary" @click="addMenu">添加菜单</el-button>
          </div>
        </el-form-item>
        <el-form-item label="功能点配置" prop="deal" v-show="!isSecondLevel">
          <deal-table ref="dealTable" :deal="form.deal" :modelsById="modelsById" @deleteOperation="deleteOperation" @setCurOperation="setCurOperation" @cloneOperation="cloneOperation"></deal-table>
          <div class="m-t-10 tx-c">
            <el-button type="primary" @click="addOPeration">添加功能点</el-button>
          </div>
        </el-form-item>
        <el-form-item label="默认字段依赖" label-width="100px">
          <div class="m-b-10 ovf-hd" v-for="(item, index) in form.rely_field">
            <el-select v-model="item.field_id" placeholder="字段" class="fl w-200 m-r-10">
              <el-option v-for="option in fieldOptions" :label="option.field + '(' + option.title +')'" :value="option.field_id"></el-option>
            </el-select>
            <el-input v-model="item.value" class="w-150 m-r-10 fl" placeholder="值"></el-input>
            <el-select v-model="item.type" placeholder="作用范围" class="fl w-200" multiple>
              <el-option v-for="option in effectRangeOptions" :label="option.name" :value="option.id"></el-option>
            </el-select>
            <el-button size="small" @click="deleteRely(index)">删除</el-button>
          </div>
          <div class="m-t-10">
            <el-button type="primary" @click="addRely">添加默认字段依赖</el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()" :loading="isLoading">提交</el-button>
          <el-button @click="goback()">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-right">
      <deal-form class="fl" :form="curOperation" :models="models" @openRule="openRule" @formChange="formChange" v-show="configType == 1"></deal-form>
      <menu-form class="fl" :menus="menus" :form="curMenu" @openRule="openRule" v-show="configType == 2"></menu-form>
      <content-form class="fl" :contents="contents" :form="curContent" @openRule="openRule" v-show="configType == 3"></content-form>
      <rule-list ref="ruleList" @selectRule="selectRule" :title="title"></rule-list>
    </div>
  </div>
</template>

<style>
  
</style>

<script>
  import ruleList from '../../Common/business/rule.vue'
  import http from '../../../assets/js/http'
  import cmsConfig from '../../../config/cmsConfig'
  import contentTable from './contentTable'
  import dealTable from './dealTable'
  import menuTable from './menuTable'
  import dealForm from './dealForm'
  import contentForm from './contentForm'
  import menuForm from './menuForm'
  export default {
    props: {
      id: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        loading: false,
        isLoading: false,
        title: '权限规则绑定',
        form: {
          name: '', // 功能名称
          level: 10, // 层级
          content: [],  // 内容配置
          deal: [], // 操作配置
          menu: {}, // 菜单配置
          rely_field: [] // 默认字段依赖
        },
        rules: {
          name: [
            { required: true, message: '请输入功能名称' }
          ],
          show_type: [
            { required: true, message: '请输入功能类型' }
          ]
        },
        contentModel: { // 功能集模型
          show_type: 10,
          arr: [
            { content_id: '', rule_id: null, rule_name: '' }
          ]
        },
        dealConfigModel: {  // 操作配置对象模型
          name: '', // 操作名
          type: 10, // 操作类型
          rule_id: '',  // 权限id
          rule_name: '',  // 权限名
          model_id: '',
          is_default: 0 // 是否默认访问
        },
        menuConfigModel: {  // 菜单配置对象模型
          pid: 0, // 上级
          title: '',  // 菜单名称
          menu_type: '', // 菜单类型
          rule_id: '', // 权限id
          rule_name: '', // 权限名
          sort: 0,  // 排序
          status: 1, // 状态
          module: ''  // 模块
        },
        relyModel: { // 字段依赖模型
          field_id: '',
          value: '',
          type: []
        },
        options: [],
        configs: [], // 功能列表
        cloneId: '',
        types: [
          { id: 10, name: '列表' },
          { id: 20, name: '添加/编辑/详情' },
          // { id: 30, name: '编辑' },
          // { id: 40, name: '详情' },
          { id: 50, name: '图表' },
          { id: 60, name: '字段扩展管理' },
          { id: 70, name: '外部链接iframe' }
        ],
        menus: [{ id: 0, title: '无' }],
        menusById: {},
        models: [],
        modelsById: {},
        contents: [],
        contentsById: {},
        curObj: {},
        curOperation: {},
        curMenu: {},
        curContent: {},
        configType: 0,
        deleteDeals: [],
        deleteMenus: {},
        deleteContents: [],
        existModelId: [],  // 已经加入选项的表单id
        fieldOptions: [],  // 默认依赖字段的可选字段
        allFieldData: {}, // 所有请求过的表单控件
        effectRangeOptions: [ // 依赖字段默认范围
          { id: 10, name: '列表搜索' },
          { id: 20, name: '添加' },
          { id: 30, name: '编辑' },
          { id: 40, name: '导入' }
        ]
      }
    },
    methods: {
      getConfigs() {
        this.apiGet('cms/contents').then((res) => {
          if (res.code == 200) {
            this.configs = res.data.list
          } else {
            _g.dealError(this, res)
          }
        })
      },
      cloneConfig() {
        if (!this.cloneId) {
          _g.toastMsg(this, 'error', '请先选择复制的功能')
          return
        }
        this.getDetail(this.cloneId, true)
      },
      addOPeration() { // 添加操作配置
        let newOperation = _.cloneDeep(this.dealConfigModel)
        if (this.form.deal && this.form.deal.length == 0) {
          newOperation.is_default = 1
        }
        this.form.deal.push(newOperation)
      },
      deleteOperation(index) { // 删除操作配置
        if (this.form.deal[index].id) {
          this.form.deal[index].is_deleted = 1
          this.deleteDeals.push(this.form.deal[index])
        }
        if (this.form.deal[index].is_default == 1 && this.form.deal.length > 1) {
          if (index == 0) {
            this.form.deal[1].is_default = 1
          } else {
            this.form.deal[0].is_default = 1
          }
        }
        this.form.deal.splice(index, 1)
        this.formChange()
      },
      cloneOperation(item, index) { // 复制操作配置
        let newOperation = _.cloneDeep(item)
        newOperation.clone_id = newOperation.id
        delete newOperation.id
        this.form.deal.splice(index + 1, 0, newOperation)
      },
      setCurOperation(item) {
        this.resetCur()
        this.configType = 1
        this.curOperation = item
      },
      addMenu() { // 添加菜单配置
        this.form.menu = _.cloneDeep(this.menuConfigModel)
      },
      deleteMenu(index) { // 删除菜单配置
        if (this.form.menu.id) {
          this.form.menu.is_deleted = 1
          this.deleteMenus = this.form.menu
        }
        this.configType = 0
        this.form.menu = {}
      },
      resetMenu(index) {  // 重置菜单配置
        this.form.menu.splice(index, 1, _.cloneDeep(this.menuConfigModel))
      },
      setCurMenu(item) {
        this.resetCur()
        this.configType = 2
        this.curMenu = item
      },
      addContent() {
        this.form.content.push(_.cloneDeep(this.contentModel))
        console.log(this.form.content)
      },
      deleteContent(index) {
        // if (this.form.content[index].id) {
        //   this.form.content[index].is_deleted = 1
        //   this.deleteContents.push(this.form.content[index])
        // }
        this.form.content.splice(index, 1)
      },
      setCurContent(item) {
        this.resetCur()
        this.configType = 3
        this.curContent = item
      },
      addRely() {
        this.form.rely_field.push(_.cloneDeep(this.relyModel))
      },
      deleteRely(index) {
        this.form.rely_field.splice(index, 1)
      },
      openRule(item) {  // 打开绑定权限弹窗
        this.curObj = item
        this.$refs.ruleList.open()
      },
      selectRule(id, title_else, title) { // 选择权限
        this.curObj.rule_id = id
        this.curObj.rule_name = title_else
      },
      getMenus() {  // 获取菜单
        this.apiGet('admin/menus').then((res) => {
          if (res.code == 200) {
            let array = []
            let menusById = {}
            _(res.data).forEach((item) => {
              if (item.level != 3 && item.menu_type == 1) {
                array.push(item)
                menusById[item.id] = item.else
              }
            })
            this.menusById = menusById
            this.menus = this.menus.concat(array)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getModels() { // 获取表单模型
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('form/models', postData).then((res) => {
          if (res.code == 200) {
            this.models = res.data.list
            let modelsById = {}
            _(this.models).forEach((item) => {
              modelsById[item.id] = item.title
            })
            this.modelsById = modelsById
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getContents() { // 获取内容列表
        let postData = {
          params: {
            is_tab: 0
          }
        }
        this.apiGet('cms/contents', postData).then((res) => {
          if (res.code == 200) {
            this.contents = res.data.list
            let contentsById = {}
            _(this.contents).forEach((item) => {
              contentsById[item.id] = item.name
            })
            this.contentsById = contentsById
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getFields(modelId) {
        return new Promise((resolve, reject) => {
          this.apiGet(`cms/deals/fields/${modelId}`).then((res) => {
            if (res.code == 200) {
              resolve(res.data)
            } else {
              _g.dealError(this, res)
              resolve([])
            }
          })
        })
      },
      getDetail(id, isClone) {
        this.loading = true
        this.apiGet(`cms/contents/${id}`).then((res) => {
          if (res.code == 200) {
            let name = this.form.name
            // let showType = this.form.show_type
            if (!res.data.menu) {
              res.data.menu = {}
            }
            this.form = res.data
            if (isClone) {
              this.form.name = name
              // this.form.show_type = showType
            }
            this.resetCur()
            this.formChange()
          } else {
            _g.dealError(this, res)
          }
          this.loading = false
        })
      },
      async formChange() { // 表单变化
        this.fieldOptions = []
        let existModelId = []
        _(this.form.deal).forEach(async (res) => {
          if (res.model_id) {
            existModelId.push(res.model_id)
            let notRepeat = Array.from(new Set(existModelId))
            if (existModelId.length != notRepeat.length) { // 存在重复的
              return
            }
            if (!this.allFieldData[res.model_id]) {
              this.allFieldData[res.model_id] = await this.getFields(res.model_id)
            }
            this.fieldOptions = this.fieldOptions.concat(this.allFieldData[res.model_id])
          }
        })
      },
      resetCur() {  // 重置当前选中的配置项
        this.curOperation = {}
        this.curMenu = {}
        this.curContent = {}
        this.$refs.contentTable.resetIndex()
        this.$refs.menuTable.resetIndex()
        this.$refs.dealTable.resetIndex()
      },
      save() {
        let notSelectType = false // 依赖字段是否没选择范围
        if (this.form.rely_field) {
          _(this.form.rely_field).forEach((res) => {
            if (_g.isRealEmpty(res.type)) {
              notSelectType = true
              return false
            }
          })
        }
        if (notSelectType) {
          _g.toastMsg(this, 'warning', '请为所有依赖字段选择默认范围')
          return
        }
        if (this.id) {
          this.edit()
        } else {
          this.add()
        }
      },
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = true
            let postData = _.cloneDeep(this.form)
            if (this.cloneId) {
              postData.clone_id = this.cloneId
              delete postData.id
            }
            this.apiPost('cms/contents', postData).then((res) => {
              if (res.code == 200) {
                _g.toastMsg(this, 'success', '保存成功！')
                _g.updateMenus()
                setTimeout(() => {
                  this.goback()
                }, 1000)
              } else {
                _g.dealError(this, res)
                this.isLoading = false
              }
            })
          }
        })
      },
      edit() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = true
            let postData = _.cloneDeep(this.form)
            postData.deal = postData.deal.concat(this.deleteDeals)
            // postData.content = postData.content.concat(this.deleteContents)
            if (postData.level == this.LEVEL_TWO) {  // 二级层级，删除操作数组
              _(postData.deal).forEach((item) => {
                if (item.id) {
                  item.is_deleted = 1
                }
              })
            } else {
              // _(postData.content).forEach((item) => {
              //   if (item.id) {
              //     item.is_deleted = 1
              //   }
              // })
            }
            this.apiPut(`cms/contents/${this.id}`, '', postData).then((res) => {
              if (res.code == 200) {
                _g.toastMsg(this, 'success', '保存成功！')
                _g.updateMenus()
                setTimeout(() => {
                  this.goback()
                }, 1000)
              } else {
                _g.dealError(this, res)
                this.isLoading = false
              }
            })
          }
        })
      },
      goback() {
        router.go(-1)
      }
    },
    created() {
      this.getMenus()
      this.getModels()
      this.getContents()
      this.getConfigs()
      if (this.id) {  // 编辑
        this.getDetail(this.id, false)
      } else {  // 添加
        // this.addOPeration()
        this.addMenu()
        // this.addContent()
      }
    },
    computed: {
      onlyOneOperation() {
        return this.form.deal.length <= 1
      },
      isSecondLevel() {  // 是否二级层级
        this.configType = 0
        return this.form.level == this.LEVEL_TWO
      },
      hasMenu() {
        return JSON.stringify(this.form.menu) !== '{}'
      }
    },
    components: {
      ruleList,
      contentTable,
      dealTable,
      menuTable,
      dealForm,
      contentForm,
      menuForm
    },
    mixins: [http, cmsConfig]
  }
</script>
<style scoped>
  .form-left{
    width:68%;
    float: left;
  }
  .left-content{
    max-height: 700px;
    overflow-y: scroll;
    padding-right: 10px;
  }
  .form-right{
    width:28%;
    float: left;
    max-height: 800px;
    overflow-y: scroll;
  }
</style>


// WEBPACK FOOTER //
// form.vue?2c33abd9